import _ from 'lodash';

import { buildTypes } from 'utils/reducer-utils';
import { prepEagerUpdate } from 'utils/eager-update-utils';
import replaceById from 'utils/replace-by-id';
import { useQuery } from 'react-query';
import store from 'app-store';
import Ticket from 'services/data/ticket';

const { SET, CLEAR } = buildTypes('tickets');

// Action creators
export function set(data) {
  store.dispatch({
    type: SET,
    data
  });
}

export function clearPageData() {
  store.dispatch({
    type: CLEAR
  });
}

export function updateTicket(updates) {
  const oldTickets = store.getState().tickets.tickets;
  const ticket = _.find(oldTickets, { uuid: updates.uuid });
  const tickets = replaceById(prepEagerUpdate(ticket, updates), oldTickets);

  store.dispatch({
    type: SET,
    data: { tickets }
  });
}

export function updateTask(updates, ticketUpdates) {
  const oldTickets = store.getState().tickets.tickets;
  const ticket = _.find(oldTickets, { id: updates.ticket });
  const task = _.find(ticket.tasks, { uuid: updates.uuid });
  const tasks = replaceById(prepEagerUpdate(task, updates), ticket.tasks);

  updateTicket({ tasks, id: ticket.id, uuid: ticket.uuid, ...ticketUpdates });
}

export function updateSingleTicket(updates) {
  const oldTicket = store.getState().tickets.ticket;
  const ticket = prepEagerUpdate(oldTicket, updates);

  store.dispatch({
    type: SET,
    data: { ticket }
  });
}

export const taskTemplateOptions = {
  cacheTime: 12 * 60 * 60 * 1000,
  staleTime: 12 * 60 * 60 * 1000,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  select: unsorted => _.orderBy(unsorted, ['sort_breadcrumb', template => _.last(template.breadcrumbs), 'index'], ['asc', 'asc', 'asc'])
};

export function useTaskTemplates(options = {}) {
  const { data: templates, ...queryData } = useQuery('task-templates', () => Ticket.taskTemplates(), { ...taskTemplateOptions, ...options });

  return { ...queryData, templates };
}



// WEBPACK FOOTER //
// ./app/routes/ticket/store/actions.js